import { render, staticRenderFns } from "./AvailabilityIndicator.vue?vue&type=template&id=12a220f4&"
import script from "./AvailabilityIndicator.vue?vue&type=script&lang=js&"
export * from "./AvailabilityIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a220f4')) {
      api.createRecord('12a220f4', component.options)
    } else {
      api.reload('12a220f4', component.options)
    }
    module.hot.accept("./AvailabilityIndicator.vue?vue&type=template&id=12a220f4&", function () {
      api.rerender('12a220f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AvailabilityIndicator.vue"
export default component.exports